import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { router } from 'modules/common/utils';
import { Icon } from 'modules/common/components';
import { PaginationWrapper, PaginationList } from './styles';
import ReportPerPageChooser from './ReportPerPageChooser';
import { range, intersection, union, difference } from '../../utils';

/**
 * @typedef {(number | string)} primitive
 * @param {primitive[]} arr1
 * @param {primitive[]} arr2
 * @returns {boolean}
 */
function hasCommonElements(arr1, arr2) {
  return arr1.some(item => arr2.includes(item));
}

// pages calculation
const generatePages = (pageCount, currentPage, screenSize) => {

  if(screenSize < 576){
    return [currentPage]
  }

  const OFFSET = 4;

  // Create an array with pageCount numbers, starting from 1
  let pages = range(1, pageCount);

  let diff;

  const first = pages.slice(0, OFFSET);
  const last = pages.slice(-OFFSET);

  const currentStart = Math.max(currentPage - 1 - OFFSET, 0);
  const currentEnd = Math.max(currentPage - 1 + OFFSET, 0);

  const current = pages.slice(currentStart, currentEnd);

  pages = [];

  if (!hasCommonElements(first, current)) {
    pages.push(...first);
    diff = current[0] - first[first.length - 1];

    if (diff === 2) {
      pages.push(current[0] - 1);
    } else if (diff !== 1) {
      pages.push(null);
    }

    pages.push(...current);
  } else {
    pages = union(first, current);
  }

  if (!hasCommonElements(last, current)) {
    diff = last[0] - pages[pages.length - 1];

    if (diff === 2) {
      pages.push(last[0] - 1);
    } else if (diff !== 1) {
      pages.push(null);
    }

    pages.push(...last);
  } else {
    diff = difference(last, current);
    pages.push(...diff);
  }
  return pages;
};

// page chooser component
class Page extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  goto(page) {
    // router.setParams(this.props.history, { page });
    this.props.onPaginationChange(page);
  }

  onClick(e) {
    const { currentPage, page } = this.props;

    e.preventDefault();
    if (page === currentPage) {
    } else {
      this.goto(this.props.page);
    }
  }

  render() {
    const { currentPage, page } = this.props;

    if (page) {
      let className = '';

      if (page === currentPage) {
        className += ' active disabled';
      }

      return (
        <li className={className} onClick={this.onClick}>
          <a 
          href='' 
          style={
            page!==currentPage ?
            {border: "1px solid #d9d9d9"} :
            {}
          }
          >
            {page}
          </a>
        </li>
      );
    }

    return (
      <li className='disabled'>
        <span>...</span>
      </li>
    );
  }
}

Page.propTypes = {
  history: PropTypes.object,
  page: PropTypes.number,
  currentPage: PropTypes.number,
};

//pagination component without controls
class ReportPaginationTotalOnly extends React.Component {
  constructor(props) {
    super(props);
  }

  renderBar() {
    const { isPaginated, count } = this.props;
	
    if (isPaginated) {
		return (
        <div
          className='align-items-center justify-content-between d-flex w-100'
          style={{ height: '52px' }}
        >
          <PaginationList>
            <span className='d-flex align-items-baseline'>
              <span className='totalRecord'>Total records</span>{' '}
              <span className='countRecord'>{count}</span>
            </span>
          </PaginationList>
        </div>
      );
    }
  }

  render() {
    return <PaginationWrapper>{this.renderBar()}</PaginationWrapper>;
  }
}

class ReportPagination extends React.Component {
  constructor(props) {
    super(props);

    // bind events
    this.onNext = this.onNext.bind(this);
    this.onPrev = this.onPrev.bind(this);
  }

  goto(page) {
    this.props.onPaginationChange(page);
  }

  onPrev(e) {
    e.preventDefault();

    const page = this.props.currentPage - 1;

    if (page > 0) {
      this.goto(page);
    }
  }

  onNext(e) {
    e.preventDefault();

    const { totalPagesCount, currentPage, onPaginationChange } = this.props;

    const page = currentPage + 1;

    if (page <= totalPagesCount) {
      this.goto(page);
    }
  }

  renderBar() {
    const {
      history,
      totalPagesCount,
      pages,
      currentPage,
      isPaginated,
      count,
    } = this.props;

    if (isPaginated) {
      let prevClass = '';
      let nextClass = '';

      if (currentPage <= 1) {
        prevClass = 'disabled';
      }

      if (currentPage >= totalPagesCount) {
        nextClass = 'disabled';
      }

      return (
        <div className='align-items-center justify-content-between d-flex w-100 flex-wrap'>
          <PaginationList>
            <span className='d-flex align-items-baseline'>
              <span className='totalRecord'>Total records</span>{' '}
              <span className='countRecord'>{count}</span>
            </span>
          </PaginationList>
          <PaginationList className='flex-wrap'>
            <span className='totalRecord'>Rows per page</span>
            {this.renderPerPageChooser()}

              <li className={prevClass}>
                <a
                  style={
                    prevClass == 'disabled'
                      ? {
                          background: '#B1B1B1',
                          opacity: '0.5',
                          color: '#fff',
                          borderRadius: '10px',
                        }
                      : {
                          border: "1px solid #d9d9d9",
                          color: "#2B3C93",
                        }
                  }
                  href=''
                  onClick={this.onPrev}
                  className='fontNormal'
                >
                  {/* <Icon icon="leftarrow-3" /> */}
                  {/* <img src="/images/left-arrow.png" /> */}
                  <span className='material-symbols-outlined'>
                    chevron_left
                  </span>
                </a>
              </li>

              {pages.map((page, index) => (
                <Page
                  key={index}
                  history={history}
                  currentPage={currentPage}
                  page={page}
                  onPaginationChange={this.props.onPaginationChange}
                />
              ))}

              <li className={nextClass}>
                <a
                  style={
                    nextClass == 'disabled'
                      ? {
                          background: '#B1B1B1',
                          opacity: '0.5',
                          color: '#fff',
                          borderRadius: '10px',
                        }
                      : {
                          border: "1px solid #d9d9d9",
                          color: "#2B3C93",
                        }
                  }
                  href=''
                  onClick={this.onNext}
                  className='fontNormal'
                >
                  {/* <Icon icon="rewind" /> */}
                  {/* <img src="/images/right-arrow.png" /> */}
                  <span className='material-symbols-outlined'>
                    chevron_right
                  </span>
                </a>
              </li>
          </PaginationList>
        </div>
      );
    }
  }

  renderPerPageChooser() {
    return (
      <ReportPerPageChooser
        history={this.props.history}
        onPerPageChooser={this.props.onPerPageChooser}
        perPage={this.props.perPage}
      />
    );
  }

  render() {
    return <PaginationWrapper showBorderTop={this.props.count}>{this.renderBar()}</PaginationWrapper>;
  }
}

ReportPagination.propTypes = {
  history: PropTypes.object,
  totalPagesCount: PropTypes.number,
  pages: PropTypes.array,
  currentPage: PropTypes.number,
  isPaginated: PropTypes.bool,
};

const ReportPaginationContainer = (props) => {
  const { history, count = 100 } = props;
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const currentPage = props.currentPage;
  const perPage = props.perPage;


  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  let totalPagesCount = parseInt(count / perPage, 10) + 1;

  if (count % perPage === 0) {
    totalPagesCount -= 1;
  }

  // calculate page numbers
  const pages = generatePages(totalPagesCount, currentPage, screenWidth);

  const childProps = {
    ...props,
    currentPage,
    isPaginated: totalPagesCount > 0,
    totalPagesCount,
    pages,
  };
  if (props.showOnlyTotalRecords) {
    return <ReportPaginationTotalOnly {...childProps} />;
  } else {
    return <ReportPagination {...childProps} />;
  }
};

ReportPaginationContainer.propTypes = {
  history: PropTypes.object,
  count: PropTypes.number,
};

export default React.memo(withRouter(ReportPaginationContainer));



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/reportPagination/ReportPagination.js